export default "__VITE_ASSET__CbyC6J3D__"